import React, { useEffect, useRef, useState } from "react";
import "./styles/Bank.css";
import Wrapper from "../components/Wrapper";
import Footer from "../components/Footer";
import { axiosInstance } from "../helper/axiosInstance";
import { staticUrl } from "../config";
import { useLanguage } from "../LanguageContext";
import { Link } from "react-router-dom";

function BankCard({ name, address, phone, website, image }) {
    const { language } = useLanguage();

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    return (
        <div className="bankPage-card">
            <Link to={'https://' + website} target="_blank" className="bankPage-card_image">
                <img src={staticUrl(image)} alt={name} />
            </Link>
            <div className="bankPage-card_content">
                <p className="bankPage-card_name">{name}</p>
                <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={dynamicStyles}
                    className="bankPage-card_link"
                >
                    {address}
                </a>
                <a href={`tel:${phone}`} style={dynamicStyles} className="bankPage-card_link">
                    {phone}
                </a>
                <Link to={'https://' + website} target="_blank" style={dynamicStyles} className="bankPage-card_link">
                    {website}
                </Link>
            </div>
        </div>
    );
}

function Banks() {
    const [showAll, setShowAll] = useState(false);
    const [maxHeight, setMaxHeight] = useState("0px");
    const contentRef = useRef(null);
    const { language, textContent } = useLanguage();
    const [banks, setbanks] = useState([]);

    useEffect(() => {
        const lang = language === "ARM" ? "hy" : language === "ENG" ? "en" : "ru";

        axiosInstance.get("/shareholders/lang?lang=" + lang).then((response) =>
            setbanks(response.data)
        );
    }, [language]);

    const isArmenian = language === "ARM";
    const dynamicStyles = {
        fontFamily: isArmenian && "Mardoto",
        fontWeight: isArmenian && 500,
    };

    useEffect(() => {
        setMaxHeight(showAll ? `${contentRef.current.scrollHeight}px` : "0px");
    }, [showAll]);

    const toggleShowAll = () => {
        setShowAll((prev) => !prev);
    };

    return (
        <Wrapper>
            <div className={`bankPage ${isArmenian && "arm-language"}`}>
                <div className="bankPage-header">
                    <span style={dynamicStyles}>{textContent[language].banksTitle}</span>
                    <div className="bankPage-header_icons">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.0164407 3.82196L0 12L3.99046 12L3.99046 3.99715C4.00629 3.99715 4.9794 4.00325 4.9794 4.0002L12 4.0002L12 -5.24537e-07L3.83761 -1.67747e-07C1.73064 -7.56487e-08 0.0219223 1.70984 0.0176598 3.82196"
                                fill="#243BE2"
                            />
                        </svg>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.17804 11.9836L0 12L0 8.00954L8.00285 8.00954C8.00285 7.99371 7.99675 7.0206 7.9998 7.0206L7.9998 0H12L12 8.16239C12 10.2694 10.2902 11.9781 8.17804 11.9823"
                                fill="#ADF233"
                            />
                        </svg>
                    </div>
                </div>
                <div className="bankPage-title">
                    <h1 style={dynamicStyles}>{textContent[language].banks}</h1>
                </div>

                <div className="bankPage-cards">
                    {banks.slice(1).map((item, index) => (
                        <BankCard key={index} {...item} />
                    ))}
                </div>
            </div>
            <Footer />
        </Wrapper>
    );
}

export default Banks;
